import { createApp } from 'vue';
import moment from 'moment';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
// import store from './store';
import '@/styles/index.styl';

moment.locale('zh-cn');

// 全局注册组件

import('@/mock/index');

createApp(App).use(router).mount('#app');
